import CellInformation from './CellInformation';

export default CellInformation;
